module.exports = __webpack_public_path__ + "static/blink-logo.dc30cba4.svg";